import { Controller } from "@hotwired/stimulus";
import { FrameElement } from "@hotwired/turbo";
import { formSubmitWithWaitForJobCompletion, waitForJobCompletion } from "../../../../../Libraries/CoreWeb/CoreWeb/Features/Jobs/jobCompletion";
import BaseStimulusModelController from "../../../../../Libraries/CoreWeb/CoreWeb/Features/Shared/BaseStimulusModelController";
import { WebPageOverviewStimulusModel } from "../../../Shared/Generated/WebPageOverviewStimulusModel";
import { formSubmitJobCompletedEventName } from "../../../../../Libraries/CoreWeb/CoreWeb/Features/Shared/TagHelpers/ViewOrEditForm/ViewOrEditFormController";
import { JobDto } from "../../../../../Libraries/CoreWeb/CoreWeb/Features/Shared/Generated/JobDto";
import { JobUrlConstants } from "../../../../../Libraries/CoreWeb/CoreWeb/Features/Shared/Generated/JobUrlConstants";
import { DomainConstants } from "../../../Shared/Generated/DomainConstants";
import { ValidationConstants } from "../../../Shared/Generated/ValidationConstants";

export const scraperWebPageNameModifiedEventName = "scraperWebPageNameModified";

export default class WebPageOverviewController extends BaseStimulusModelController<WebPageOverviewStimulusModel> {
    static targets = [
        "url",
        "previousUrl",
        "name",
        "scrapingByBrowserWaitFor"
    ];
   
    declare urlTarget: HTMLInputElement;
    declare previousUrlTarget: HTMLInputElement;
    declare nameTarget: HTMLInputElement;
    declare scrapingByBrowserWaitForTarget: HTMLSelectElement;

    connect() {
        if (this.modelValue.isEmptyWebPage) {
            requestAnimationFrame(() => {
                this.urlTarget.scrollIntoView({ behavior: "smooth", block: "center" });
                this.urlTarget.focus();                
            });
        }
    }

    onUrlModified() {
        let url = this.urlTarget.value.trim();
        let urlWithoutHttpPrefix = this.getUrlWithoutHttpPrefix(url);
        let previousUrlWithoutHttpPrefix = this.getUrlWithoutHttpPrefix(this.previousUrlTarget.value);
        if (!this.nameTarget.value || this.nameTarget.value === previousUrlWithoutHttpPrefix) {
            this.nameTarget.value = urlWithoutHttpPrefix.substring(0, ValidationConstants.scraperWebPageNameMaxLength).trim();
            this.dispatchScraperWebPageNameModifiedEvent();
        }
        
        this.previousUrlTarget.value = url;
    }

    private getUrlWithoutHttpPrefix(url: string): string {
        return url.replace(/^https?:\/\//i, "");
    }

    onNameModified() {
        this.dispatchScraperWebPageNameModifiedEvent();
    }

    private dispatchScraperWebPageNameModifiedEvent() {
        let name = this.nameTarget.value.trim();
        this.nameTarget.dispatchEvent(new CustomEvent(scraperWebPageNameModifiedEventName, { bubbles: true, detail: name }));
    }

    onScrapeHtmlAsRenderedByBrowseToggled(event: Event) {
        if (!event.currentTarget) return;
        const checkbox = event.currentTarget as HTMLInputElement;
        const scrapeHtmlAsRenderedByBrowser = checkbox.checked;

        this.scrapingByBrowserWaitForTarget.style.display = scrapeHtmlAsRenderedByBrowser ? "" : "none";
    }
}